import React from 'react'

const IconFacebook = ({ style = {}, ...props }) => {
  return (
    <svg
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      style={style}
      {...props}>
      <title>Fill-1</title>
      <g
        id="Pricing-page"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="Pricing-Copy"
          transform="translate(-549.000000, -547.000000)"
          fill="#1877F2"
          fillRule="nonzero">
          <g id="Group" transform="translate(480.000000, 189.000000)">
            <g id="Social-buttons" transform="translate(53.000000, 350.000000)">
              <g id="Fill-1-Clipped" transform="translate(16.000000, 8.000000)">
                <path
                  d="M20,10 C20,4.47714844 15.5228516,0 10,0 C4.47714844,0 0,4.47714844 0,10 C0,14.9912891 3.65685547,19.1283203 8.4375,19.8785156 L8.4375,12.890625 L5.8984375,12.890625 L5.8984375,10 L8.4375,10 L8.4375,7.796875 C8.4375,5.290625 9.93042969,3.90625 12.2146484,3.90625 C13.3087305,3.90625 14.453125,4.1015625 14.453125,4.1015625 L14.453125,6.5625 L13.1921484,6.5625 C11.9499023,6.5625 11.5625,7.33333984 11.5625,8.12416016 L11.5625,10 L14.3359375,10 L13.8925781,12.890625 L11.5625,12.890625 L11.5625,19.8785156 C16.3431445,19.1283203 20,14.9912891 20,10"
                  id="Fill-1"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default IconFacebook
